import React from 'react';
import Input, { Props as InputProps } from '../Input2';
import FormGroup, { Props as FormGroupProps } from '../FormGroup';

export type Props = Omit<FormGroupProps, 'children'> &
  Omit<InputProps, 'onChange' | 'hasError'>;
export default function InputGroup(
  props: Props & { onChange: (v: string) => void },
) {
  const {
    error,
    type,
    label,
    labelInfo,
    icon,
    id,
    autoFocus = false,
    className = '',
    large = false,
    placeholder,
    inputRef,
    extraLarge,
    onChange,
    onKeyPress,
    onBlur,
    autoComplete,
    helperText,
    withoutMargin = false,
    value,
    onKeyDown,
    enterKeyHint,
    required,
  } = props;
  return (
    <FormGroup
      id={id}
      error={error}
      helperText={helperText}
      label={label}
      labelInfo={labelInfo}
      withoutMargin={withoutMargin}
    >
      <Input
        id={id}
        hasError={!!error}
        inputRef={inputRef}
        type={type}
        extraLarge={extraLarge}
        autoFocus={autoFocus}
        placeholder={placeholder}
        large={large}
        onKeyDown={onKeyDown}
        icon={icon}
        className={className}
        onChange={e => onChange(e?.currentTarget?.value || '')}
        value={value}
        onBlur={onBlur}
        autoComplete={autoComplete}
        enterKeyHint={enterKeyHint}
        onKeyPress={onKeyPress}
        required={required}
      />
    </FormGroup>
  );
}
